module.exports = __webpack_public_path__ + "img/nic.b8c9f5e4.svg";